import { IState } from 'interfaces/redux/IState';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

/**
 * A typed version of the standard redux useSelector() function.
 * Can be used just like the useSelector() version:
 *  "const patient = useTypedSelector(state => state.patient);"
 */
export const useTypedSelector: TypedUseSelectorHook<IState> = useSelector;
